<template>
  <fragment>
    <quill-editor
      v-on="$listeners"
      v-bind="[$attrs, $props]"
      ref="quillComponent"
      :options="
        me.role === 'FOUR_NETWORK'
          ? editorOption
          : isLeads
          ? editorOptionLeads
          : me.role === 'PARTICIPANT' &&
            me.medalBenefities.includes('ADVANCED_FORMATTING')
          ? editorOptionRanking
          : editorOptionCommon
      "
      :class="
        me.role === 'FOUR_NETWORK'
          ? 'quill-editor'
          : isLeads
          ? 'quill-editor-leads'
          : isDebate
          ? 'quill-editor-debate'
          : me.role === 'PARTICIPANT' &&
            me.medalBenefities.includes('ADVANCED_FORMATTING')
          ? 'quill-editor-ranking'
          : 'quill-editor-common'
      "
      @change="updateMentionList"
      @ready="onEditorReady"
    />
    <Picker
      v-if="showEmojiPicker"
      class="quill-emoji-picker"
      :style="emojiPickerStyle"
      @select="addEmoji"
      :show-preview="false"
      :disable-skin-tones="true"
      :i18n="emojiI18n"
    />
    <GifPicker
      v-if="showGifPicker"
      :style="gifPickerStyle"
      @select="insertGif"
      @api-unavailable="onGifApiUnavailable"
      class="quill-gif-picker"
    />
    <div
      v-if="classQuill"
      v-html="$t('post.limitCaracter')"
      class="redAlert--text body-2"
    />
  </fragment>
</template>
<script lang="ts">
import Component, { mixins } from "vue-class-component";
import { ActionMixin } from "../../mixins/ActionMixin";
import { Action } from "vuex-class";
import { Event } from "@/types";
import { Prop } from "vue-property-decorator";
import i18n from "@/plugins/i18n";
import Quill from "quill";
import "quill-paste-smart";
import { Picker } from "emoji-mart-vue";
import GifPicker from "./GifPicker.vue";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EmbedBase: any = (Quill as any).import("blots/embed");
class GifBlot extends EmbedBase {
  static blotName = "gif";
  static tagName = "img";
  static className = "post-gif";
  static create(url: string): HTMLImageElement {
    const node = super.create() as HTMLImageElement;
    node.setAttribute("src", url);
    node.setAttribute("alt", "GIF");
    node.setAttribute("loading", "lazy");
    return node;
  }
  static value(node: HTMLElement): string {
    return node.getAttribute("src") || "";
  }
}
(Quill as any).register({ "formats/gif": GifBlot }, true);
let items: any[] = [];
let searchWord = "";
@Component({
  components: {
    Picker,
    GifPicker,
  },
})
export default class BaseQuillEditor extends mixins(ActionMixin) {
  @Prop(Array) currentEvent: any;
  @Prop(String) currentPublic: string;
  @Prop({ default: "" }) classQuill: string;
  @Prop(Array) currentCommunity: any;
  @Prop() me: any;
  @Prop(Boolean) isLeads: boolean;
  @Prop(Boolean) isDebate: boolean;
  @Action("post/requestUsersMark") requestUsersMark: any;
  publicItems = [
    {
      name: i18n.t("modal.modalEventsInPostAll"),
      id: "ALL",
    },
    {
      name: i18n.t("modal.modalEventsInPostClevels"),
      id: "C_LEVELS",
    },
    {
      name: i18n.t("modal.modalEventsInPostPartners"),
      id: "PARTNERS",
    },
  ];
  showEmojiPicker = false;
  showGifPicker = false;
  gifApiAvailable = true;
  emojiPickerStyle: Record<string, string> = {};
  gifPickerStyle: Record<string, string> = {};
  emojiI18n = {
    search: i18n.t("emoji.search"),
    notfound: i18n.t("emoji.notfound"),
    categories: {
      search: i18n.t("emoji.categories.search"),
      recent: i18n.t("emoji.categories.recent"),
      smileys: i18n.t("emoji.categories.smileys"),
      people: i18n.t("emoji.categories.people"),
      nature: i18n.t("emoji.categories.nature"),
      foods: i18n.t("emoji.categories.foods"),
      activity: i18n.t("emoji.categories.activity"),
      places: i18n.t("emoji.categories.places"),
      objects: i18n.t("emoji.categories.objects"),
      symbols: i18n.t("emoji.categories.symbols"),
      flags: i18n.t("emoji.categories.flags"),
      custom: i18n.t("emoji.categories.custom"),
    },
  };
  editorOption = {
    modules: {
      toolbar: {
        container: [
          ["bold", "italic", "underline", "strike"],
          ["blockquote", "code-block", "link", "image"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ align: [] }],
        ],
      },
      mention: {
        allowedChars: /^[A-Za-z0-9\sÀ-ÖØ-öø-ÿ]*$/,
        mentionDenotationChars: ["@"],
        source: async function (
          searchTerm: any,
          renderItem: any,
          mentionChar: string
        ) {
          if (mentionChar === "@" && searchTerm.length !== 0) {
            searchWord = searchTerm;
            setTimeout(() => {
              renderItem(items, mentionChar);
            }, 500);
          }
        },
        renderItem: (item: any, mentionChar: any) => {
          if (mentionChar === "@") {
            const borderClass =
              item.role === "PARTICIPANT"
                ? "mention-border mention-border__avatar-green"
                : item.role === "EXECUTIVE"
                ? "mention-border mention-border__avatar-red"
                : item.role === "EQUIPE"
                ? "mention-border mention-border__avatar-black"
                : item.role === "PARTNER"
                ? "mention-border mention-border__avatar-blue"
                : "mention-border company-profile-border";
            return item.hasMedal
              ? `
 <div class="d-inline-flex py-2 align-center">
 <img src="${item.profileImage}" class="${borderClass}" />
 <div class="pl-2 align-center">
 <p class="gray70--text subtitle-2 mb-0 d-inline-flex">
 ${item.name}
 </p>
 <img src="${require("../../assets/medal.svg")}" class="pl-1" />
 <p class="black--text caption mb-0">
 ${item.companyName}
 </p>
 </div>
 </div>
 `
              : item.role === "MARKETING"
              ? `
 <div class="d-inline-flex py-2 align-center">
 <img src="${item.profileImage}" class="${borderClass}" />
 <div class="pl-2 align-center">
 <p class="gray70--text subtitle-2 mb-0">
 ${item.name}
 </p>
 </div>
 </div>
 `
              : `
 <div class="d-inline-flex py-2 align-center">
 <img src="${item.profileImage}" class="${borderClass}" />
 <div class="pl-2 align-center">
 <p class="gray70--text subtitle-2 mb-0">
 ${item.name}
 </p>
 <p class="black--text caption mb-0">
 ${item.companyName}
 </p>
 </div>
 </div>
 `;
          }
          return mentionChar + item.name;
        },
      },
      clipboard: {
        allowed: {
          tags: [
            "a",
            "b",
            "strong",
            "u",
            "s",
            "i",
            "p",
            "br",
            "ul",
            "ol",
            "li",
            "span",
          ],
          attributes: ["href", "rel", "target", "class"],
        },
        keepSelection: false,
        substituteBlockElements: true,
        magicPasteLinks: true,
        hooks: {
          uponSanitizeElement(node: any) {
            if (node instanceof Element)
              node.innerHTML = node.innerHTML.replace(/&nbsp;/g, "");
          },
        },
      },
    },
    placeholder: i18n.t("post.placeholderQuill"),
  };
  editorOptionRanking = {
    modules: {
      toolbar: {
        container: [
          ["bold", "italic", "underline", "strike"],
          ["blockquote", "code-block"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ align: [] }],
        ],
      },
      mention: {
        allowedChars: /^[A-Za-z0-9\sÀ-ÖØ-öø-ÿ]*$/,
        mentionDenotationChars: ["@"],
        source: async function (
          searchTerm: any,
          renderItem: any,
          mentionChar: string
        ) {
          if (mentionChar === "@" && searchTerm.length !== 0) {
            searchWord = searchTerm;
            setTimeout(() => {
              renderItem(items, mentionChar);
            }, 500);
          }
        },
        renderItem: (item: any, mentionChar: any) => {
          if (mentionChar === "@") {
            const borderClass =
              item.role === "PARTICIPANT"
                ? "mention-border mention-border__avatar-green"
                : item.role === "EXECUTIVE"
                ? "mention-border mention-border__avatar-red"
                : item.role === "EQUIPE"
                ? "mention-border mention-border__avatar-black"
                : item.role === "PARTNER"
                ? "mention-border mention-border__avatar-blue"
                : "mention-border company-profile-border";
            return item.hasMedal
              ? `
                <div class="d-inline-flex py-2 align-center">
                  <img src="${item.profileImage}" class="${borderClass}" />
                  <div class="pl-2 align-center">
                    <p class="gray70--text body-2 font-weight-bold mb-0 d-inline-flex">
                      ${item.name}
                    </p>
                    <img src="${require("../../assets/medal.svg")}" class="pl-1" />
                    <p class="black--text caption mb-0">
                      ${item.companyName}
                    </p>
                  </div>
                </div>
              `
              : item.role === "MARKETING"
              ? `
                <div class="d-inline-flex py-2 align-center">
                  <img src="${item.profileImage}" class="${borderClass}" />
                  <div class="pl-2 align-center">
                    <p class="gray70--text body-2 font-weight-bold mb-0">
                      ${item.name}
                    </p>
                  </div>
                </div>
              `
              : `
                <div class="d-inline-flex py-2 align-center">
                  <img src="${item.profileImage}" class="${borderClass}" />
                  <div class="pl-2 align-center">
                    <p class="gray70--text body-2 font-weight-bold mb-0">
                      ${item.name}
                    </p>
                    <p class="black--text caption mb-0">
                      ${item.companyName}
                    </p>
                  </div>
                </div>
              `;
          }
          return mentionChar + item.name;
        },
      },
      clipboard: {
        allowed: {
          tags: [],
          attributes: [],
        },
        keepSelection: false,
        substituteBlockElements: true,
        magicPasteLinks: false,
      },
    },
    placeholder: i18n.t("post.placeholder"),
  };
  editorOptionLeads = {
    modules: {
      toolbar: ["caracs"],
      clipboard: {
        allowed: {
          tags: [],
          attributes: [],
        },
        keepSelection: false,
        substituteBlockElements: true,
        magicPasteLinks: false,
      },
    },
    placeholder: i18n.t("leads.comment"),
  };
  editorOptionCommon = {
    modules: {
      toolbar: [],
      mention: {
        allowedChars: /^[A-Za-z0-9\sÀ-ÖØ-öø-ÿ]*$/,
        mentionDenotationChars: ["@"],
        source: async function (
          searchTerm: any,
          renderItem: any,
          mentionChar: string
        ) {
          if (mentionChar === "@" && searchTerm.length !== 0) {
            searchWord = searchTerm;
            setTimeout(() => {
              renderItem(items, mentionChar);
            }, 500);
          }
        },
        renderItem: (item: any, mentionChar: any) => {
          if (mentionChar === "@") {
            const borderClass =
              item.role === "PARTICIPANT"
                ? "mention-border mention-border__avatar-green"
                : item.role === "EXECUTIVE"
                ? "mention-border mention-border__avatar-red"
                : item.role === "EQUIPE"
                ? "mention-border mention-border__avatar-black"
                : item.role === "PARTNER"
                ? "mention-border mention-border__avatar-blue"
                : "mention-border company-profile-border";
            return item.hasMedal
              ? `
 <div class="d-inline-flex py-2 align-center">
 <img src="${item.profileImage}" class="${borderClass}" />
 <div class="pl-2 align-center">
 <p class="gray70--text subtitle-2 mb-0 d-inline-flex">
 ${item.name}
 </p>
 <img src="${require("../../assets/medal.svg")}" class="pl-1" />
 <p class="black--text body-2 mb-0">
 ${item.companyName}
 </p>
 </div>
 </div>
 `
              : item.role === "MARKETING"
              ? `
 <div class="d-inline-flex py-2 align-center">
 <img src="${item.profileImage}" class="${borderClass}" />
 <div class="pl-2 align-center">
 <p class="gray70--text subtitle-2 mb-0">
 ${item.name}
 </p>
 </div>
 </div>
 `
              : `
 <div class="d-inline-flex py-2 align-center">
 <img src="${item.profileImage}" class="${borderClass}" />
 <div class="pl-2 align-center">
 <p class="gray70--text subtitle-2 mb-0">
 ${item.name}
 </p>
 <p class="black--text body-2 mb-0">
 ${item.companyName}
 </p>
 </div>
 </div>
 `;
          }
          return mentionChar + item.name;
        },
      },
      clipboard: {
        allowed: {
          tags: [],
          attributes: [],
        },
        keepSelection: false,
        substituteBlockElements: true,
        magicPasteLinks: false,
      },
    },
    placeholder: i18n.t("post.placeholder"),
  };
  async updateMentionList(item: any): Promise<void> {
    const mention = item.text.split("@");
    if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm)
      for (let element of document.getElementsByClassName("mention")) {
        element.addEventListener(
          "click",
          this.removeMention.bind(null, element.attributes.item(3)?.value)
        );
      }
    if (mention.length === 1) return;
    const audience = this.publicItems.find(
      (audienceType: any) => audienceType.name === this.currentPublic
    );
    const audienceType = audience?.id || "ALL";
    const payload = {
      nameFilter: searchWord,
      audienceType: audienceType,
      eventIds: this.currentEvent.reduce(
        (string: string, event: Event, index: number) => {
          if (index === this.currentEvent.length - 1)
            string += String(event.id);
          else if (event.id || event.id === 0) string += event.id + ",";
          return string;
        },
        ""
      ),
      loungeIds: this.currentCommunity.reduce(
        (string: string, community: Event, index: number) => {
          if (index === this.currentCommunity.length - 1)
            string += String(community.id);
          else if (community.id || community.id === 0)
            string += community.id + ",";
          return string;
        },
        ""
      ),
    };
    await this.withLoading(async () => {
      await this.requestUsersMark(payload).then((data: any) => {
        items = data;
        items.forEach((item: any) => {
          item.value = item.name;
        });
      });
    });
  }
  removeMention(event: any): void {
    for (let item of document.getElementsByClassName("mention")) {
      if (item.attributes.item(3)?.value === event) item.remove();
    }
  }

  addEmoji(emoji: any): void {
    const quillComponent = this.$refs.quillComponent as any;
    const quill = quillComponent?.quill;

    if (!quill) return;

    const range = quill.getSelection(true);
    const index = range ? range.index : quill.getLength() - 1;

    quill.insertText(index, emoji.native, "user");
    quill.setSelection(index + emoji.native.length, 0, "user");

    this.showEmojiPicker = false;
  }

  insertGif(gif: { url: string; previewUrl: string }): void {
    const quillComponent = this.$refs.quillComponent as any;
    const quill = quillComponent?.quill;
    if (!quill) return;
    const range = quill.getSelection(true);
    const index = range ? range.index : quill.getLength() - 1;
    quill.insertEmbed(index, "gif", gif.url, "user");
    quill.setSelection(index + 1, 0, "user");
    this.showGifPicker = false;
  }

  onGifApiUnavailable(): void {
    this.gifApiAvailable = false;
    this.updateGifButtonState();
  }

  updateGifButtonState(): void {
    const quillComponent = this.$refs.quillComponent as any;
    const root = quillComponent?.$el as HTMLElement;
    const toolbar = root?.querySelector(".ql-toolbar");
    const gifBtn = toolbar?.querySelector(
      ".ql-gif"
    ) as HTMLButtonElement | null;
    if (gifBtn) {
      gifBtn.disabled = !this.gifApiAvailable;
    }
  }

  mounted(): void {
    const gifVal = localStorage.getItem("tenor:unavailable_until");
    if (gifVal && Date.now() < Number(gifVal)) {
      this.gifApiAvailable = false;
    }
  }

  onEditorReady(): void {
    this.addToolbarButtons();
  }

  addToolbarButtons(): void {
    const quillComponent = this.$refs.quillComponent as any;
    const root = quillComponent?.$el as HTMLElement;
    const toolbar = root?.querySelector(".ql-toolbar");

    if (toolbar && !toolbar.querySelector(".ql-emoji")) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "ql-emoji";
      button.onclick = () => {
        if (!this.showEmojiPicker) {
          const r = button.getBoundingClientRect();
          this.emojiPickerStyle = {
            position: "fixed",
            top: `${r.bottom + 6}px`,
            left: `${Math.max(8, r.right - 354)}px`,
            zIndex: "9999",
          };
        }
        this.showEmojiPicker = !this.showEmojiPicker;
      };
      toolbar.appendChild(button);
    }

    if (toolbar && !toolbar.querySelector(".ql-gif")) {
      const gifButton = document.createElement("button");
      gifButton.type = "button";
      gifButton.className = "ql-gif";
      gifButton.disabled = !this.gifApiAvailable;
      gifButton.onclick = () => {
        if (!gifButton.disabled) {
          if (!this.showGifPicker) {
            const r = gifButton.getBoundingClientRect();
            this.gifPickerStyle = {
              position: "fixed",
              top: `${r.bottom + 6}px`,
              left: `${Math.max(8, r.right - 300)}px`,
              zIndex: "9999",
            };
          }
          this.showGifPicker = !this.showGifPicker;
        }
      };
      toolbar.appendChild(gifButton);
    }
  }
}
</script>
<style lang="sass">
.quill-editor-error
  border: 2px solid var(--v-redAlert-base) !important
.quill-editor
  background: var(--v-white-base) !important
  .ql-blank, .ql-editor
    min-height: 240px
  .ql-tooltip, .ql-editing
    left: 0 !important
.quill-editor-common
  .ql-toolbar
    display: none
  .ql-tooltip, .ql-editing
    left: 0 !important
  .ql-container
    background: var(--v-white-base) !important
    border: 1px solid var(--v-gray15-base) !important
    border-radius: 16px !important
.quill-editor-ranking
  .ql-toolbar
    display: flex
.quill-editor-leads
  .ql-blank, .ql-editor
    min-height: 150px
  .ql-toolbar
    display: none
  .ql-tooltip, .ql-editing
    left: 0 !important
  .ql-container
    background: var(--v-white-base) !important
    border: 0.5px solid var(--v-gray30-base) !important
    border-radius: 0px !important
.quill-editor-debate
  .ql-toolbar
    display: flex
    background: var(--v-white-base) !important
    border-radius: 8px 8px 0 0 !important
    border: 0.5px solid var(--v-gray30-base) !important
  .ql-tooltip, .ql-editing
    left: 0 !important
  .ql-container
    background: var(--v-white-base) !important
    border: 0.5px solid var(--v-gray30-base) !important
    border-radius: 0 0 8px 8px  !important
iframe.ql-video
  height: 300px !important
  width: 100% !important
.mention
  background-color: var(--v-purple40-base) !important
  color: var(--v-purple100-base) !important
  border-radius: 4px !important
  padding: 2px !important
.ql-mention-list
  padding: 0 !important
.mention-border
  height: 40px !important
  width: 40px !important
  min-width: 40px !important
  max-width: 40px !important

  &__avatar-black
    border: 2px solid var(--v-black-base) !important
    border-radius: 50px !important

  &__avatar-red
    border: 2px solid var(--v-redExecutive-base) !important
    border-radius: 50px !important

  &__avatar-green
    border: 2px solid var(--v-greenCLevel-base) !important
    border-radius: 50px !important

  &__avatar-blue
    border: 2px solid var(--v-bluePartner-base) !important
    border-radius: 50px !important

.ql-emoji
  width: 28px !important
  height: 24px !important
  background-image: url('../../assets/icons/emoji.svg') !important
  background-repeat: no-repeat !important
  background-position: center !important
  background-size: 18px !important

.ql-emoji::before
  display: none !important

.ql-emoji svg
  display: none

.quill-editor,
.quill-editor-ranking,
.quill-editor-debate
  position: relative

.ql-gif
  width: 28px !important
  height: 24px !important
  background-image: url('../../assets/icons/gif.svg') !important
  background-repeat: no-repeat !important
  background-position: center !important
  background-size: 18px !important

.ql-gif::before
  display: none !important

.ql-gif svg
  display: none

.quill-emoji-picker
  z-index: 9999

.quill-gif-picker
  z-index: 9999

.post-gif
  max-width: 280px
  max-height: 200px
  border-radius: 8px
  display: inline-block
  vertical-align: middle
  margin: 2px 4px
</style>
